import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=2310c1d6&scoped=true"
import script from "./fields.vue?vue&type=script&lang=js"
export * from "./fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2310c1d6",
  null
  
)

export default component.exports